<zip-co-header></zip-co-header>

<main [style.backgroundImage]="'url(' + appPrefix + '/assets/background-light.svg)'">
  <div class="container">
    <div class="right">
      <h1 class="error__heading">Gift Cards will be back ASAP!</h1>
      <p class="error__copy">
        In the meantime, you can shop now and pay later with Zip at over 14,000 stores.
      </p>
      <a class="btn" href="/au/shop">
        Continue shopping
      </a>
    </div>
    <div class="partner__logos-container">
      <div class="partner__logos">
        <div class="partner__logo">
          <img src="assets/partner-logos/target-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/kmart-logo.png" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/bunnings-logo.png" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/kogan-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/officeworks-logo.png" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/rebel-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/general-pants-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/fantastic-furniture-logo.png" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/supercheap-auto-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/tigerair-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/amart-furniture-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/catch-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/scoopon-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/best-and-less-logo.svg" alt="" />
        </div>
        <div class="partner__logo">
          <img src="assets/partner-logos/thermonix-logo.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>
